import { CancelToken } from 'axios';
import axiosInstance from '../API/createAxisInstance';
import config from 'config';
import { getStore } from 'configureStore';
import { routeMap } from 'router';

import { get } from 'lodash';
import { push } from 'redux-little-router';

export default class API {
  static baseUrl = config.tapsAttachApiUrl;

  /**
   * @param {'GET'|'PUT'|'POST'|'DELETE'} method
   * @param {string} url
   * @param {object} [params]
   * @param responseType
   * @param {object} [data]
   * @param {object} [headers]
   * @param paramsSerializer
   * @param {function} [mapper]
   * @param {bool} [cancelable]
   * @returns {AxiosPromise}
   */
  static request(
    {
      method,
      url,
      params,
      responseType = 'json',
      data,
      headers,
      paramsSerializer,
      mapper = (data) => data,
    },
    cancelable,
  ) {
    let cancel = null;
    const request = axiosInstance({
      method,
      url: `${API.baseUrl}${url}`,
      params,
      data,
      responseType,
      headers,
      paramsSerializer,
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    }).then((response) => {
      if (response.isOk) {
        return { ...response, data: mapper(response.data) };
      } else {
        if (get(response, 'error.response.data.errorType') === 'isDemo') {
          getStore().dispatch(
            push({
              pathname: routeMap.error,
              query: {
                title: 'Функционал недоступен',
                message:
                  'В демонстрационном режиме данный функционал недоступен. Для его использования Вы можете авторизоваться в полной версии личного кабинета ФЛ.',
                backPage: window.location,
              },
            }),
          );
        }
        return response;
      }
    });
    return cancelable ? { cancel, request } : request;
  }
}

export function uploadService(data, inn) {
  return API.request({
    method: 'POST',
    data,
    url: `/upload/${inn}`,
    responseType: 'text',
  });
}
/**
 * Download pdf from messages page
 * @param {string} pdf
 * @param {string} inn
 * @param {string} attachmentId
 * @param {string} attachmentType
 * @param {Object} cancelObj
 * @returns {Promise}
 */
export function downLoadTapsFileWithAttachType(
  pdf,
  inn,
  attachmentId,
  attachmentType,
  notificationId,
  cancelObj = {},
) {
  return API.request({
    method: 'GET',
    url: `/download/${inn}`,
    params: {
      filename: pdf,
      attachmentId,
      attachmentType,
      notificationId,
    },
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    responseType: 'arraybuffer',

    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      cancelObj[pdf] = c;
    }),
  });
}

export function downloadTapsFile(pdf, inn, cancelObj = {}) {
  return API.request({
    method: 'GET',
    url: encodeURI(`/download/${inn}?filename=${pdf}`),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    responseType: 'arraybuffer',

    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      cancelObj[pdf] = c;
    }),
  });
}

export function unpackZip({ inn, fileName }) {
  return API.request({
    method: 'POST',
    url: `/unpack/${inn}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      filename: fileName,
    },
  });
}
